import { Handshake } from "lucide-react";
import FolderView from "@/components/FolderView";

const FOLDERS = [
  "UN", "WHO", "AU", "EU", "G20", "BRICS", "NATO", "IMF",
  "World Bank", "WTO", "ICC", "OPEC", "Commonwealth",
  "African Union", "Shanghai Cooperation Organisation",
];

export default function Multilaterals() {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-xl flex items-center justify-center">
            <Handshake className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="font-['Barlow_Condensed'] text-3xl font-bold text-app tracking-wide">
              MULTILATERALS
            </h1>
            <p className="text-app">International organisations & multilateral agreements</p>
          </div>
        </div>
      </div>

      <FolderView subHub="multilaterals" folders={FOLDERS} icon={Handshake} color="indigo" />
    </div>
  );
}
